import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ContentCanvas.css";

const ContentCanvas = ({
    isOpen,
    onClose,
    postContent,
    blogData,
    onPostPublished,
    onBlogPublished,
    translations
}) => {
    const [activeTab, setActiveTab] = useState("both");
    const [editedPost, setEditedPost] = useState(postContent || "");
    const [editedBlog, setEditedBlog] = useState({
        title: blogData?.title || "",
        content: blogData?.content || "",
        imageUrl: blogData?.imageUrl || ""
    });
    const [isPublishing, setIsPublishing] = useState(false);
    const [publishStatus, setPublishStatus] = useState(null);

    // const t = translations || {}; // Removed unused variable

    // Update internal state if props change (e.g., Repli generates new content)
    useEffect(() => {
        setEditedPost(postContent || "");
    }, [postContent]);

    useEffect(() => {
        setEditedBlog({
            title: blogData?.title || "",
            content: blogData?.content || "",
            imageUrl: blogData?.imageUrl || ""
        });
    }, [blogData]);

    if (!isOpen) return null;

    const handlePublish = async () => {
        setIsPublishing(true);
        setPublishStatus(null);

        try {
            if (activeTab === "post" || activeTab === "both") {
                await axios.post(
                    `${process.env.REACT_APP_API_URL}/api/social/posts`,
                    { content: editedPost },
                    { withCredentials: true }
                );
                setPublishStatus("post");
                if (onPostPublished) onPostPublished();
            }

            if (activeTab === "blog" || activeTab === "both") {
                await axios.post(
                    `${process.env.REACT_APP_API_URL}/api/blog`,
                    {
                        title: editedBlog.title,
                        content: editedBlog.content,
                        imageUrl: editedBlog.imageUrl,
                        date: new Date().toISOString()
                    },
                    { withCredentials: true }
                );
                setPublishStatus(publishStatus === "post" ? "both" : "blog");
                if (onBlogPublished) onBlogPublished();
            }

            setTimeout(() => {
                setPublishStatus(null);
                onClose(); // Auto-cerrar el canvas
            }, 2000);

        } catch (error) {
            console.error("Error publishing from canvas:", error);
            setPublishStatus("error");
        } finally {
            setIsPublishing(false);
        }
    };

    return (
        <div className="content-canvas">
            <div className="canvas-header">
                <div className="header-info">
                    <h3>Edición de Contenido</h3>
                    <span className="subtitle">Retoca tu post y blog antes de lanzar</span>
                </div>
                <div className="header-actions">
                    <button
                        className="canvas-publish-btn"
                        onClick={handlePublish}
                        disabled={isPublishing}
                    >
                        {isPublishing ? (
                            <span className="loader-mini"></span>
                        ) : (
                            <>Aceptar y Publicar</>
                        )}
                    </button>
                    <button className="canvas-close-btn" onClick={onClose} title="Cerrar">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" /></svg>
                    </button>
                </div>
            </div>

            <div className="canvas-tabs">
                <button
                    className={`canvas-tab-btn ${activeTab === "both" ? "active" : ""}`}
                    onClick={() => setActiveTab("both")}
                >
                    Todo
                </button>
                <button
                    className={`canvas-tab-btn ${activeTab === "post" ? "active" : ""}`}
                    onClick={() => setActiveTab("post")}
                >
                    Post Social
                </button>
                <button
                    className={`canvas-tab-btn ${activeTab === "blog" ? "active" : ""}`}
                    onClick={() => setActiveTab("blog")}
                >
                    Blog SEO
                </button>
            </div>

            <div className="canvas-body">
                {publishStatus && (
                    <div className={`canvas-status-banner ${publishStatus}`}>
                        {publishStatus === "error" ? "❌ Error al publicar" : "✨ ¡Publicado con éxito!"}
                    </div>
                )}

                <div className="canvas-scroll-area">
                    {(activeTab === "post" || activeTab === "both") && (
                        <div className="canvas-section">
                            <label>Contenido del Post</label>
                            <textarea
                                value={editedPost}
                                onChange={(e) => setEditedPost(e.target.value)}
                                placeholder="Escribe el post aquí..."
                                rows={6}
                            />
                        </div>
                    )}

                    {(activeTab === "blog" || activeTab === "both") && (
                        <div className="canvas-section">
                            <label>Blog: Título</label>
                            <input
                                type="text"
                                value={editedBlog.title}
                                onChange={(e) => setEditedBlog({ ...editedBlog, title: e.target.value })}
                                placeholder="Título del artículo..."
                                className="canvas-input"
                            />

                            <label>Blog: Contenido</label>
                            <textarea
                                value={editedBlog.content}
                                onChange={(e) => setEditedBlog({ ...editedBlog, content: e.target.value })}
                                placeholder="Contenido del blog..."
                                rows={12}
                            />

                            <label>Imagen del Blog (URL)</label>
                            <div className="image-preview-container">
                                <input
                                    type="text"
                                    value={editedBlog.imageUrl}
                                    onChange={(e) => setEditedBlog({ ...editedBlog, imageUrl: e.target.value })}
                                    placeholder="URL de la imagen..."
                                    className="canvas-input"
                                />
                                {editedBlog.imageUrl && (
                                    <img src={editedBlog.imageUrl} alt="Preview" className="canvas-image-preview" />
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContentCanvas;
